export default "__VITE_ASSET__deeb5db3__"